import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

@Component({
	selector: 'app-vertical',
	templateUrl: './vertical.component.html',
	styleUrls: ['./vertical.component.scss'],
})
export class VerticalComponent implements OnInit {
	isCondensed = false;
	isLoading: boolean = false;
	showSidebar: boolean = true;

	constructor(private router: Router) {}

	ngOnInit(): void {
		document.documentElement.setAttribute('data-layout', 'vertical');
		document.documentElement.setAttribute('data-topbar', 'light');
		document.documentElement.setAttribute('data-sidebar', 'dark');
		document.documentElement.setAttribute('data-layout-style', 'default');
		document.documentElement.setAttribute('data-layout-mode', 'light');
		document.documentElement.setAttribute('data-layout-width', 'fluid');
		document.documentElement.setAttribute('data-layout-position', 'fixed');
		document.documentElement.setAttribute('data-sidebar-image', 'none');

		const currentUrl = this.router.url;
		if (!currentUrl.startsWith('/calendar')) {
			document.documentElement.setAttribute('data-sidebar-size', 'lg');
			this.showSidebar = true;
		} else {
			document.documentElement.setAttribute('data-sidebar-size', 'none');
			this.showSidebar = false;
		}
		this.router.events.subscribe((event) => {
			if (event instanceof NavigationEnd) {
				if (!event.urlAfterRedirects.startsWith('/calendar')) {
					document.documentElement.setAttribute('data-sidebar-size', 'lg');
					this.showSidebar = true;
				} else {
					document.documentElement.setAttribute('data-sidebar-size', 'none');
					this.showSidebar = false;
				}
			}
		});

		window.addEventListener('resize', function () {
			if (window.screen.width <= 767) {
				document.documentElement.setAttribute('data-sidebar-size', '');
			} else if (window.screen.width <= 1024) {
				document.documentElement.setAttribute('data-sidebar-size', 'sm');
			} else if (window.screen.width >= 1024) {
				document.documentElement.setAttribute('data-sidebar-size', 'lg');
			}
		});
	}

	/**
	 * On mobile toggle button clicked
	 */
	onToggleMobileMenu() {
		const currentSIdebarSize = document.documentElement.getAttribute('data-sidebar-size');
		if (window.screen.width >= 767) {
			if (currentSIdebarSize == null) {
				document.documentElement.getAttribute('data-sidebar-size') == null || document.documentElement.getAttribute('data-sidebar-size') == 'lg' ? document.documentElement.setAttribute('data-sidebar-size', 'sm') : document.documentElement.setAttribute('data-sidebar-size', 'lg');
			} else if (currentSIdebarSize == 'md') {
				document.documentElement.getAttribute('data-sidebar-size') == 'md' ? document.documentElement.setAttribute('data-sidebar-size', 'sm') : document.documentElement.setAttribute('data-sidebar-size', 'md');
			} else {
				document.documentElement.getAttribute('data-sidebar-size') == 'sm' ? document.documentElement.setAttribute('data-sidebar-size', 'lg') : document.documentElement.setAttribute('data-sidebar-size', 'sm');
			}
		}

		if (window.screen.width <= 767) {
			document.body.classList.toggle('vertical-sidebar-enable');
		}
		this.isCondensed = !this.isCondensed;
	}

	/**
	 * on settings button clicked from topbar
	 */
	onSettingsButtonClicked() {
		document.body.classList.toggle('right-bar-enabled');
		const rightBar = document.getElementById('theme-settings-offcanvas');
		if (rightBar != null) {
			rightBar.classList.toggle('show');
			rightBar.setAttribute('style', 'visibility: visible;');
		}
	}
}
